import React from 'react';
import QCXAlert from './QCXAlert';

export default function QCXWarningAlert(props) {
  return (
    <QCXAlert
      {...props}
      severity="warning"
    />
  );
}
